import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SearchService } from '@brafton/atlas-api-client';
import {
    SearchHit, SearchItem, SearchResult, Suggestion, SuggestOption
} from '@brafton/atlas-api-client/lib/models/search.model';

@Component({
  templateUrl: './search.view.html',
  styleUrls: ['./search.view.scss'],
})
export class SearchView implements OnInit, OnDestroy {
  searchTerm?: string;
  autocompleteHits: SearchHit<SearchItem>[] = [];
  searchResults$?: Observable<SearchHit<SearchItem>[]>;
  hits: SearchHit<SearchItem>[] = [];
  phraseSuggestions: Suggestion | undefined = undefined;
  spellSuggestions: Suggestion | undefined = undefined;
  autocompleteSubscription: any = undefined;
  suggestions: SuggestOption[] = [];
  subscriptions = new Subscription();
  numberOfHits = 0;

  constructor(private searchService: SearchService, private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.activatedRoute.queryParams.subscribe((qp) => {
        if (qp['searchTerm']) {
          this.searchTerm = qp['searchTerm'].split(':')[0];
          this.search(this.searchTerm as string);
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  search(searchTerm: string): void {
    this.searchResults$ = undefined;

    this.searchResults$ = this.searchService.performSearch(searchTerm).pipe(
      map((data: SearchResult<SearchItem>) => {
        this.numberOfHits = 25;
        return data.hits;
      }),
    );
  }
}
